import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

const base: SVGProps<SVGSVGElement> = {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': true,
    focusable: false,
}

export function WarningIcon(props: IconProps) {
    return (
        <svg {...base} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.88635 2.00279C7.3947 1.17094 8.60285 1.17094 9.1112 2.00279L15.5972 12.6162C16.1281 13.485 15.5029 14.5998 14.4848 14.5998H1.51278C0.494681 14.5998 -0.130535 13.485 0.400354 12.6162L6.88635 2.00279ZM8.08727 2.62853C8.04683 2.56236 7.95073 2.56236 7.91029 2.62853L1.42429 13.242C1.38206 13.3111 1.4318 13.3998 1.51278 13.3998H14.4848C14.5658 13.3998 14.6155 13.3111 14.5733 13.242L8.08727 2.62853ZM7.99896 10.2292C7.66759 10.2292 7.39896 9.96054 7.39896 9.62917V5.83287C7.39896 5.5015 7.66759 5.23287 7.99896 5.23287C8.33033 5.23287 8.59896 5.5015 8.59896 5.83287V9.62917C8.59896 9.96054 8.33033 10.2292 7.99896 10.2292ZM8.00658 12.6811C8.42999 12.6811 8.77324 12.3379 8.77324 11.9145C8.77324 11.491 8.42999 11.1478 8.00658 11.1478C7.58316 11.1478 7.23991 11.491 7.23991 11.9145C7.23991 12.3379 7.58316 12.6811 8.00658 12.6811Z"
                fill="currentColor"
            />
        </svg>
    )
}

export function ErrorIcon(props: IconProps) {
    return (
        <svg {...base} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.05a6.95 6.95 0 1 0 0 13.9A6.95 6.95 0 0 0 8 1.05Zm.6 3.95a.6.6 0 0 0-1.2 0v4a.6.6 0 0 0 1.2 0v-4Zm0 6a.65.65 0 1 0-1.3 0 .65.65 0 0 0 1.3 0Z"
                fill="currentColor"
            />
        </svg>
    )
}

export function CheckIcon(props: IconProps) {
    return (
        <svg {...base} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.8047 3.52851C14.0674 3.79122 14.0674 4.21714 13.8047 4.47985L6.80474 11.4799C6.54203 11.7426 6.11611 11.7426 5.8534 11.4799L2.19527 7.82172C1.93256 7.55901 1.93256 7.13309 2.19527 6.87038C2.45798 6.60767 2.8839 6.60767 3.14661 6.87038L6.32907 10.0528L12.8534 3.52851C13.1161 3.2658 13.542 3.2658 13.8047 3.52851Z"
                fill="currentColor"
            />
        </svg>
    )
}
